/**
 * useTasks — Hook for filtered/sorted task lists
 *
 * Merges provided filter with store's statusFilter/ownerFilter state.
 * Uses Zustand selector with shallow equality for optimized re-renders.
 */

import { useMemo } from 'react';
import { useTaskStore } from '../store/taskStore';
import type { TaskFilter } from '../types';
import type { BackendTask } from '../types';

export function useTasks(filter?: TaskFilter): BackendTask[] {
  const getFilteredTasks = useTaskStore((s) => s.getFilteredTasks);
  const statusFilter = useTaskStore((s) => s.statusFilter);
  const ownerFilter = useTaskStore((s) => s.ownerFilter);
  const tasks = useTaskStore((s) => s.tasks);

  return useMemo(() => {
    const mergedFilter: TaskFilter = {
      statusMode: statusFilter,
      ownerMode: ownerFilter,
      ...filter, // explicit filter overrides store defaults
    };
    return getFilteredTasks(mergedFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasks, statusFilter, ownerFilter, filter, getFilteredTasks]);
}
